import type { FC, ReactNode } from 'react';
import React, { Fragment } from 'react';

import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';

export const OptionalMenuListItem: FC<{ asListItem: boolean; children: ReactNode }> = ({
	asListItem,
	children,
}) => (asListItem ? <MenuListItem>{children}</MenuListItem> : <Fragment>{children}</Fragment>);
